export default "__VITE_ASSET__BKT_cDni__"